import Clipboard from 'clipboard'

function addCopyListener(container) {
  const button = container.querySelector('[data-copy-button]');
  const invite = container.querySelector('[data-copy-input]');

  const clipboard = new Clipboard(button, {
    text: () => {
      return invite.value
    },
  })

  clipboard.on('success', (e) => {
    const initialCopy = e.trigger.textContent

    invite.select()
    e.trigger.textContent = 'Copied!'
    window.setTimeout(() => {
      e.trigger.textContent = initialCopy
    }, 2000)
  })

  clipboard.on('error', () => {
    invite.select()
  })
}

const InviteCopy = {
  mounted() {
    addCopyListener(this.el)
  },
}

export default InviteCopy
